import { render } from "./CodeExchange.vue?vue&type=template&id=cd1a7012&scoped=true&ts=true"
import script from "./CodeExchange.vue?vue&type=script&lang=ts"
export * from "./CodeExchange.vue?vue&type=script&lang=ts"

import "./CodeExchange.vue?vue&type=style&index=0&id=cd1a7012&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd1a7012"]])

export default __exports__